import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import './index.scss';

export default class ForgotPassword extends React.Component {
  constructor() {
    super();

    this.state = {
      submittedEmail: '',
    };

    this.onForgotFormSubmit = this.onForgotFormSubmit.bind(this);
  }

  componentDidMount() {
    this.props.forgotPasswordReset();
  }

  onForgotFormSubmit(event) {
    event.preventDefault();

    const email = event.target.email.value;
    this.setState({ submittedEmail: email });

    this.props.postForgotPassword({
      email,
    });
  }

  render() {
    let message = '';
    if (this.props.auth.forgotPasswordRequestAccepted === true || this.props.auth.forgotPasswordRequestAccepted === false) {
      message = `A password reset email has been sent to ${this.state.submittedEmail} if a Truelark account exists with this email.`;
    }

    return (
      <div className="auth-forgot-password">
        <div className="auth-forgot-password__container">
          <h4>Forgot Password?</h4>
          <div
            className="message message--success"
          >
            {message}
          </div>
          <form onSubmit={this.onForgotFormSubmit}>
            <div className="form-group">
              <label htmlFor="email">Enter your email</label>
              <input type="text" name="email" />
            </div>
            <div className="form-group">
              <button type="submit">Submit</button>
            </div>
          </form>
          <div className="auth-forgot-password__container__sign-up">
            Already have a TrueLark account? &nbsp;{' '}
            <NavLink to="/login">Sign in</NavLink>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.defaultProps = {
  forgotPasswordReset: () => { },
  postForgotPassword: () => { },
  auth: {
    forgotPasswordRequestAccepted: false,
  },
};

ForgotPassword.propTypes = {
  forgotPasswordReset: PropTypes.func,
  postForgotPassword: PropTypes.func,
  auth: PropTypes.shape({
    forgotPasswordRequestAccepted: PropTypes.bool,
  }),
};
